import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IRestoreState } from '../sso-login.models';

@Component({
  selector: 'app-restore-account',
  templateUrl: './restore-account.component.html',
  styleUrls: ['./restore-account.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RestoreAccountComponent {
  @Input({ required: true }) restore!: IRestoreState;

  @Output() restored = new EventEmitter<void>();
  @Output() accountSwitched = new EventEmitter<void>();
}
